import {
  MatFormFieldModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
} from "@angular/material";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ReferralRoutingModule } from "./referrals-routing.module";
import { ReferralsSpecialistComponent } from "./referrals-specialist/referrals-specialist.component";
import { ReferralsComponent } from "./referrals/referrals.component";
import { ReferPatientComponent } from "./refer-patient/refer-patient.component";
import { CoreModule } from "../core/core.module";
import { SharedModule } from "../shared/shared.module";
import { PatientsModule } from "../patients/patients.module";
import { PractitionersModule } from "../practitioners/practitioners.module";
import { PractitionerApptComponent } from "./practitioner-appt/practitioner-appt.component";
import { MatSelectModule } from "@angular/material/select";
import { HttpClientModule } from "@angular/common/http";
import { MaterialModule } from "../material/material-module";
import { RatingModule } from "ng-starrating";
import { IonicModule } from "@ionic/angular";
import { NgbModalModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { AgmCoreModule } from "@agm/core";
import { CKEditorModule } from "ckeditor4-angular";
import { PhysicianLayoutComponent } from "../physician/layout/physician-layout.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ReferralRoutingModule,
    CoreModule,
    SharedModule,
    MatFormFieldModule,
    PatientsModule,
    PractitionersModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatSelectModule,
    MaterialModule,
    RatingModule,
    IonicModule,
    NgbModalModule,
    NgbCollapseModule,
    AgmCoreModule,
    CKEditorModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ReferralsSpecialistComponent,
    ReferralsComponent,
    ReferPatientComponent,
    PractitionerApptComponent,
  ],
  bootstrap: [PhysicianLayoutComponent],
})
export class ReferralsModule {}
